import _memoize from 'lodash/memoize';
import { HD, FULL_HD } from '@bedrock-rdk/constants';
import { makeThemeColor, PRIMARY, TERTIARY } from '@tornado-rdk/theme';
import { getFont, FONT } from '@tornado-rdk/typography';
import { cacheResolver, makeDefaultStylingContext } from '../../../../tornado/utils/style';
import { middle } from '../../../../tornado/utils/sizes';

export const defaultContext = makeDefaultStylingContext();

export const HEIGHT = {
  [HD]: 48,
  [FULL_HD]: 72,
};

export const ICON_SIZE = {
  [HD]: 32,
  [FULL_HD]: 40,
};

export const ICON_MARGIN_RIGHT = {
  [HD]: 8,
  [FULL_HD]: 16,
};

export const SPACER_END = {
  [HD]: 32,
  [FULL_HD]: 32,
};

export const LABEL_UNFOCUSED_ALPHA = 0;

export const FOCUSED_ALPHA = 1;

export const colors = {
  icon: makeThemeColor(PRIMARY),
  iconFocused: makeThemeColor(TERTIARY),
  iconBackground: makeThemeColor(TERTIARY, 0.3),
  iconBackgroundFocused: makeThemeColor(PRIMARY),
  text: makeThemeColor(PRIMARY),
  background: makeThemeColor(TERTIARY, 0.3),
  border: makeThemeColor(PRIMARY, 0.1),
};

export const getInitialStyle = (context = defaultContext) => {
  const { screenSize, colorMode } = context;
  const font = getFont(FONT.OTTAWA_2, screenSize);

  return {
    h: HEIGHT[screenSize],
    Background: {
      alpha: 0,
      rect: true,
      h: HEIGHT[screenSize],
      shader: {
        radius: Math.round(HEIGHT[screenSize] / 2),
        fillColor: colors.background[colorMode],
        strokeColor: colors.border[colorMode],
        stroke: 1.25,
      },
    },
    IconWrapper: {
      w: HEIGHT[screenSize],
      h: HEIGHT[screenSize],
      IconBackground: {
        rect: true,
        w: HEIGHT[screenSize],
        h: HEIGHT[screenSize],
        shader: {
          fillColor: colors.iconBackground[colorMode],
          radius: Math.round(HEIGHT[screenSize] / 2),
        },
      },
      Icon: {
        color: colors.icon[colorMode],
        mount: 0.5,
        x: middle,
        y: middle,
      },
    },
    Label: {
      x: HEIGHT[screenSize] + ICON_MARGIN_RIGHT[screenSize],
      alpha: LABEL_UNFOCUSED_ALPHA,
      mountY: 0.5,
      y: middle,
      color: colors.text[colorMode],
      text: {
        ...font,
        verticalAlign: 'middle',
      },
    },
  };
};

export const getFocusedStyle = _memoize(
  ({ colorMode }) => ({
    Background: {
      smooth: { alpha: 1 },
    },
    IconWrapper: {
      IconBackground: {
        smooth: {
          'shader.fillColor': colors.iconBackgroundFocused[colorMode],
        },
      },
      Icon: {
        smooth: {
          color: colors.iconFocused[colorMode],
        },
      },
    },
    Label: {
      smooth: {
        alpha: FOCUSED_ALPHA,
      },
    },
  }),
  cacheResolver,
);

export const getUnFocusedStyle = _memoize(
  ({ colorMode }) => ({
    Background: {
      smooth: { alpha: 0 },
    },
    IconWrapper: {
      IconBackground: {
        smooth: {
          'shader.fillColor': colors.iconBackground[colorMode],
        },
      },
      Icon: {
        smooth: {
          color: colors.icon[colorMode],
        },
      },
    },
    Label: {
      smooth: {
        alpha: LABEL_UNFOCUSED_ALPHA,
      },
    },
  }),
  cacheResolver,
);
